function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 11.5V6.32998C15 5.79998 14.79 5.28998 14.41 4.91998L12.7 3.20998C12.31 2.81998 11.68 2.81998 11.29 3.20998L9.59 4.90998C9.21 5.28998 9 5.79998 9 6.32998V7.49998H5C3.9 7.49998 3 8.39998 3 9.49998V19.5C3 20.6 3.9 21.5 5 21.5H19C20.1 21.5 21 20.6 21 19.5V13.5C21 12.4 20.1 11.5 19 11.5H15ZM7 19.5H5V17.5H7V19.5ZM7 15.5H5V13.5H7V15.5ZM7 11.5H5V9.49998H7V11.5ZM13 19.5H11V17.5H13V19.5ZM13 15.5H11V13.5H13V15.5ZM13 11.5H11V9.49998H13V11.5ZM13 7.49998H11V5.49998H13V7.49998ZM19 19.5H17V17.5H19V19.5ZM19 15.5H17V13.5H19V15.5Z",
  fill: "currentColor"
});

function SvgProperty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.cce143de.svg";
export { ForwardRef as ReactComponent };